import { Config } from '#lib/constants/config.js';
import { NewsRoutes } from '#lib/websites/news/constants/routes.js';

export const getHeniNewsArticleOnClickUrl = (
	url: string | undefined | null
) => {
	const urlBits = url?.split(Config.Domain);
	return urlBits
		? urlBits[urlBits?.length - 1]?.replace(
				NewsRoutes.Article,
				NewsRoutes.MobileArticle
			)
		: null;
};
